import { QueryClient } from "@tanstack/react-query";

/**
 * Singleton QueryClient, shared between main.tsx (provider) and
 * store/auth.ts (cache clearing on logout).
 *
 * Without this, switching users in the same tab without a full page
 * reload (sign out, sign back in as someone else) can serve a stale
 * cached response fetched under the *previous* user's account — e.g. a
 * supersuperadmin's cross-account user list still showing after
 * switching to a regular admin scoped to one account.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: 2,
    },
  },
});
